var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccreditations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 0.9375C10.7812 0.419733 11.201 0 11.7188 0H18.2812C18.799 0 19.2188 0.419733 19.2188 0.9375V2.8125H23.4375C25.5086 2.8125 27.1875 4.49143 27.1875 6.5625V26.25C27.1875 28.3211 25.5086 30 23.4375 30H6.5625C4.49143 30 2.8125 28.3211 2.8125 26.25V6.5625C2.8125 4.49143 4.49143 2.8125 6.5625 2.8125H10.7812V0.9375ZM12.6562 2.8125H17.3438V1.875H12.6562V2.8125Z",
    fill: "#F302CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.09375C10.7322 6.09375 10.3125 6.51348 10.3125 7.03125C10.3125 7.54902 10.7322 7.96875 11.25 7.96875H18.75C19.2678 7.96875 19.6875 7.54902 19.6875 7.03125C19.6875 6.51348 19.2678 6.09375 18.75 6.09375H11.25Z",
    fill: "#081327"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9844 13.125C18.9844 15.3255 17.2005 17.1094 15 17.1094C12.7995 17.1094 11.0156 15.3255 11.0156 13.125C11.0156 10.9245 12.7995 9.14062 15 9.14062C17.2005 9.14062 18.9844 10.9245 18.9844 13.125Z",
    fill: "#081327"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67188 23.2031C8.67188 19.707 11.5039 16.875 15 16.875C18.4961 16.875 21.3281 19.707 21.3281 23.2031C21.3281 23.7209 20.9084 24.1406 20.3906 24.1406H9.60938C9.09161 24.1406 8.67188 23.7209 8.67188 23.2031Z",
    fill: "#081327"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 25.7812C7.91973 25.7812 7.5 26.201 7.5 26.7188C7.5 27.2365 7.91973 27.6562 8.4375 27.6562H21.5625C22.0803 27.6562 22.5 27.2365 22.5 26.7188C22.5 26.201 22.0803 25.7812 21.5625 25.7812H8.4375Z",
    fill: "#081327"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.90625C6.98223 8.90625 6.5625 9.32598 6.5625 9.84375V13.125C6.5625 13.6428 6.98223 14.0625 7.5 14.0625C8.01777 14.0625 8.4375 13.6428 8.4375 13.125V9.84375C8.4375 9.32598 8.01777 8.90625 7.5 8.90625Z",
    fill: "#081327"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.90625C21.9822 8.90625 21.5625 9.32598 21.5625 9.84375V13.125C21.5625 13.6428 21.9822 14.0625 22.5 14.0625C23.0178 14.0625 23.4375 13.6428 23.4375 13.125V9.84375C23.4375 9.32598 23.0178 8.90625 22.5 8.90625Z",
    fill: "#081327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccreditations);
export default __webpack_public_path__ + "static/media/Accreditations.e89ac51a86a99c9dc9d36521be3b4b14.svg";
export { ForwardRef as ReactComponent };